var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_742_2299)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3C6.04537 3 3.5 5.54537 3.5 8.5C3.5 8.77614 3.27614 9 3 9C2.72386 9 2.5 8.77614 2.5 8.5C2.5 4.99309 5.49309 2 9 2C12.5069 2 15.5 4.99309 15.5 8.5C15.5 12.0069 12.5069 15 9 15C8.72386 15 8.5 14.7761 8.5 14.5C8.5 14.2239 8.72386 14 9 14C11.9546 14 14.5 11.4546 14.5 8.5C14.5 5.54537 11.9546 3 9 3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.646447 6.64645C0.841709 6.45118 1.15829 6.45118 1.35355 6.64645L3 8.29289L4.64645 6.64645C4.84171 6.45118 5.15829 6.45118 5.35355 6.64645C5.54882 6.84171 5.54882 7.15829 5.35355 7.35355L3 9.70711L0.646447 7.35355C0.451184 7.15829 0.451184 6.84171 0.646447 6.64645Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_742_2299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.4d6e31543828c02b7be7fadda6eb9b90.svg";
export { ForwardRef as ReactComponent };